module.exports = __webpack_public_path__ + "static/media/IllustracionEjecutivoBig.9069d7b5.svg";